import useQueryParams from './use-query-params';

export default function useQueryParam(param: string) {
  return useQueryParams()[param];
}
